import { useEffect } from 'react';

interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
}

function setMeta(name: string, content: string) {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function setProperty(property: string, content: string) {
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('property', property);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

export function useSeo({ title, description, keywords }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    setMeta('description', description);
    if (keywords) {
      setMeta('keywords', keywords);
    }
    setProperty('og:title', title);
    setProperty('og:description', description);
    setProperty('og:type', 'website');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
  }, [title, description, keywords]);
}